
// 文件类型
export const FILE_TYPE = {
    COVER: 2, //封面
    VIEDO: 1, //视频
}